module.exports = __webpack_public_path__ + "img/upload-dp.5d2efe0d.svg";